(function (angular) {
    'use strict';

    angular.module('ui.order.newOrder.addressService', [])

        .service('newOrderAddressService', function (customersRepository) {
            var _this = this;

            angular.extend(_this, {
                getAddresses: getAddresses,
                addAddress: addAddress,
                getCustomerTitle: getCustomerTitle
            });

            var _addressComparableFields = ["companyName",
                                            "contactTitle",
                                            "contactFirstName",
                                            "contactLastName",
                                            "email",
                                            "telephone",
                                            "postalCode",
                                            "country",
                                            "region",
                                            "city",
                                            "line1",
                                            "line2"];

            var _titleMaxLength = 80;

            return _this;

            function getAddresses(customerId) {
                return customersRepository.getCustomer(customerId)
                    .then(function (customerModel) {
                        return customersRepository.getCustomerDeliveryAddresses(customerId)
                            .then(function (deliveryAddressModels) {
                                var viewAddresses = _.map(deliveryAddressModels, function (addressModel) {
                                    return toAddress(addressModel, false);
                                });
                                viewAddresses.unshift(toAddress(customerModel.$model.address, true));

                                return getUniqueAddresses(viewAddresses);
                            });
                    });
            }

            function addAddress(addresses, address) {
                var index = findItemIndex(addresses, address);
                if (index === -1) {
                    updateAddress(address, 0, '#FFEBEE');
                    addresses.push(address);
                } else {
                    address = addresses[index];
                }

                return address.hashCode;
            }

            function toAddress(addressModel, isPrimary) {
                var address = {};
                _.each(_addressComparableFields, function (field) {
                    address[field] = addressModel.$model[field];
                });
                updateAddress(address, addressModel.$model.id, isPrimary ? '#E8F5E9' : '#FFF8E1');

                return address;
            }

            function updateAddress(address, id, color) {
                address.id = id;
                address.style = {};
                address.style['background-color'] = color;

                setHashCode(address);
                setContact(address);
                setTitle(address);
                setPostal(address);
            }

            function setHashCode(address) {
                address.hashCode = getHashCode(address);
            }

            function setContact(address) {
                address.contact = joinModelFields(address, ["contactTitle",
                                                            "contactFirstName",
                                                            "contactLastName"], " ");
            }

            function setTitle(address) {
                address.title = combineTitle(address.contact, address, ["city", "telephone", "email"]);
            }

            function setPostal(address) {
                address.postal = joinModelFields(address, ["postalCode", "country", "region", "city"], " ");
            }

            function getHashCode(address) {
                var hashCode = 0;

                var str = JSON.stringify(address);
                for (var i = 0; i < str.length; i++) {
                    hashCode += str.charCodeAt(i) * (i + 1);
                }

                hashCode = hashCode * 100000 + address.id;

                return hashCode.toString();
            }

            function getUniqueAddresses(addresses) {
                return _.filter(addresses, function (item1, index) {
                    var foundIndex = findItemIndex(addresses, item1);
                    return index === foundIndex;
                });
            }

            function findItemIndex(addresses, item) {
                return _.findIndex(addresses, function (i) {
                    return areAddressesEqual(item, i);
                });
            }

            function areAddressesEqual(address1, address2) {
                return _.every(_addressComparableFields, function (field) {
                    return areStringsEqual(address1[field], address2[field]);
                });
            }

            function areStringsEqual(str1, str2) {
                if (str1 && !str2) return false;
                if (!str1 && str2) return false;
                if (!str1 && !str2) return true;

                return removeWhitespaces(str1).toLowerCase() === removeWhitespaces(str2).toLowerCase();
            }

            function removeWhitespaces(str) {
                return str.replace(/\s+/g, '');
            }

            function getCustomerTitle(customer) {
                var address = customer.address.$model;
                var prefix = address.companyName ? address.companyName : customer.code;

                return combineTitle(prefix, address, ["country", "city", "line1", "line2"]);
            }

            function combineTitle(prefix, address, fields) {
                var title = _.str.sprintf("%s [%s", prefix, joinModelFields(address, fields, ", "));

                return _.str.sprintf("%s]", _.str.truncate(title, _titleMaxLength));
            }

            function joinModelFields(model, fields, delimiter) {
                var result = "";
                _.each(fields, function (field) {
                    if (model[field]) {
                        if (result) result += delimiter;
                        result += model[field];
                    }
                });

                return result;
            }
        })
    ;
})(window.angular);
